define([
    "dojo/_base/lang",
    "../../../constants/TypeConstants",
    "../../../constants/DisplayStateConstants",
    "../../../constants/DisplayModeConstants",
    "../properties/HideRestoreDefaultsQABOptionProperty",
    "../properties/TypeProperty",
    "../properties/TagProperty"
],
    function (lang, TypeConstants, DisplayStateConstants, DisplayModeConstants, HideRestoreDefaultsQABOptionProperty,
              TypeProperty, TagProperty) {
        var hash = {};

        hash[TypeConstants.TOOLSTRIP] = lang.mixin({
            displayState: {
                type: "string",
                notInAction: true,
                defaultValue: DisplayStateConstants.EXPANDED
            },
            displayMode: {
                type: "string",
                notInAction: true,
                defaultValue: DisplayModeConstants.DEFAULT
            },
            QABId: {
                type: "string",
                notInAction: true,
                defaultValue: ""
            },
            selectedTab: {
                type: "String",
                notInAction: true,
                defaultValue: ""
            }
        }, HideRestoreDefaultsQABOptionProperty, TypeProperty, TagProperty);
        return hash;
    });